import {Adapter} from "@netent/playui-origin-adapter";

export const initAdapter = (settings) => {
    const adapter = new Adapter(window.Services, {
        gameName: Platform.isDesktopDevice ? "JACK HAMMER\u2122" : "JACK HAMMER TOUCH\u2122",
        containers: {
            keypad: document.querySelector(".play-ui"),
            dialog: document.querySelector(".playui-dialog")
        },
        settings: settings
    });

    return adapter;
};
